export default __webpack_public_path__ + "static/media/TECH.e6cbd19c.jpg";